import '.e5{font-size:1.125rem;}.ssr-plugin'
import '.eh{line-height:1.75rem;}.ssr-plugin'
import '.hx{text-decoration:none;}.ssr-plugin'
import '.g2{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e5 eh"
    >
      {translations.privacySubtitle}{' '}
      <a className="hx g2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hx g2"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
